import React from 'react';

const About = () => {
  return (
    <div id="about" className="container">
      <div className="content">
        <div className="col left">
          <img src="./img/about.jpg" alt="" />
        </div>
        <div className="col right">
          <h2>FOUNDER - About Us</h2>
          <p>The Anti-Bully Clothing Co. was created by Gladys Henriquez and her mother Daly Perez. When you purchase one of our cool and stylish shirts not only are you supporting a woman owned small business, you are also promoting a good message.</p>
          <p><span className="bold">Help us continue the fight against Bullying!</span> We'll be donating part of our proceeds to a local anti-bully organization.</p>
          <a href="http://www.gladyshenriquez.com/" target="_blank">Learn more about Gladys here >></a>
        </div>
      </div>
    </div>
  )
}

export default About;



// WEBPACK FOOTER //
// ./src/components/home/About.js